
<template>
  <v-row>
    <v-col cols="12" sm="12" md="6" lg="6">
      <div class="wrapper">
        <ejs-datetimepicker
          floatLabelType="auto"
          ref="startDateRef"
          :locale="locale"
          :placeholder="`${$t('Start')} *`"
          :value="startDateTime"
          :format="dateFormat"
          :change="onStartDateChange"
          :allowEdit="true"
          :showClearButton="false"
          :step="15"
          :enableMask="true"
          :strictMode="true"
          :blur="onBlurStartDate"
          :enabled="enabled"
        ></ejs-datetimepicker>
      </div>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <div class="wrapper">
        <ejs-datetimepicker
          floatLabelType="auto"
          ref="endDateRef"
          :locale="locale"
          :placeholder="`${$t('End')} *`"
          :min="minEndDate"
          :value="endDateTime"
          :format="dateFormat"
          :change="onEndDateChange"
          :allowEdit="true"
          :showClearButton="false"
          :step="15"
          :enableMask="true"
          :strictMode="true"
          :blur="onBlurEndDate"
          :enabled="enabled"
        ></ejs-datetimepicker>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import Vue from "vue";
import { extend, loadCldr, L10n, setCulture } from "@syncfusion/ej2-base";
import {
  DateTimePickerPlugin,
  DateTimePicker,
  MaskedDateTime,
} from "@syncfusion/ej2-vue-calendars";

Vue.use(DateTimePickerPlugin);
DateTimePicker.Inject(MaskedDateTime);
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/ja/ca-gregorian.json"),
  require("cldr-data/main/ja/numbers.json"),
  require("cldr-data/main/ja/timeZoneNames.json")
);
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);
export default {
  props: {
    startDate: {
      type: [String, Date],
      default: "",
    },
    endDate: {
      type: [String, Date],
      default: "",
    },
    endDateAutoIncrease: {
      type: Number,
      default: 120,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      waterMark: "Select a datetime",
      today: this.roundToNearest(new Date()),
      dateStart: "",
      dateEnd: "",
    };
  },

  watch: {
    endDate: {
      immediate: true,
      deep: true,
      async handler() {
        if (this.endDate) {
          this.dateEnd = this.endDate;
        } else {
          this.dateEnd = this.AddMinutesToDate(
            new Date(),
            this.endDateAutoIncrease
          ).toISOString();
          this.$emit("update:endDate", this.dateEnd);
        }
      },
    },
    startDate: {
      immediate: true,
      deep: true,
      async handler() {
        if (this.startDate) {
          this.dateStart = this.startDate;
        } else {
          this.dateStart = new Date().toISOString();
          this.$emit("update:startDate", this.dateStart);
        }
      },
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm";
    },
    startDateTime: {
      get() {
        return this.dateStart ? new Date(this.dateStart) : new Date();
      },
      set(val) {
        this.dateStart = val;
      },
    },

    endDateTime: {
      get() {
        return this.dateEnd ? new Date(this.dateEnd) : new Date();
      },
      set(val) {
        this.dateEnd = val;
      },
    },

    minEndDate() {
      // return this.startDateTime; // Comment by hitesh on 15/12/2022
      return this.roundTimeQuarterHour(new Date(this.startDateTime));
    },
  },
  methods: {
    onStartDateChange,
    onEndDateChange,
    roundToNearest,
    roundToNearest15,
    roundTimeQuarterHour,
    AddMinutesToDate(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    onBlurStartDate() {
      this.$refs.startDateRef.hide();
    },
    onBlurEndDate() {
      this.$refs.endDateRef.hide();
    },
  },
  provide: {
    datetimepicker: [MaskedDateTime],
  },
};

function roundTimeQuarterHour(time) {
  const timeToReturn = new Date(time);

  timeToReturn.setMilliseconds(0);
  timeToReturn.setSeconds(0);
  timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);

  return timeToReturn;
}

function roundToNearest(date = new Date()) {
  const dateN = this.roundToNearest15();
  return new Date(dateN.getTime() - 15 * 60000);
}

function roundToNearest15(date = new Date()) {
  const minutes = 15;
  const ms = 1000 * 60 * minutes;

  return new Date(Math.ceil(date.getTime() / ms) * ms);
}

function onStartDateChange(event) {
  const date = new Date(event.value);
  this.startDateTime = date;
  this.$emit("update:startDate", date.toISOString());
  if (this.endDateTime.getTime() <= this.startDateTime.getTime()) {
    const newDate = this.AddMinutesToDate(
      new Date(date),
      this.endDateAutoIncrease
    ).toISOString();
    this.$emit("update:endDate", newDate);
  }
}

function onEndDateChange(event) {
  const endDate = new Date(event.value);
  let date = endDate;
  if (endDate.getTime() <= this.startDateTime.getTime()) {
    date = this.AddMinutesToDate(
      new Date(endDate.toISOString()),
      this.endDateAutoIncrease
    ).toISOString();
  }
  this.endDateTime = date;
  this.$emit("update:endDate", this.endDateTime.toISOString());
}
</script>
<style>
.e-float-input.e-control-wrapper:not(.e-error) input:valid ~ label.e-float-text,
.e-float-input.e-input-group input {
  padding: 4px 6px !important;
}
:root {
  /* CSS variable for body's width */
  --width-body: 100vw;
}
.wrapper {
  min-width: 250px;
  background: #f2f2f2 !important;
}
.e-calendar {
  max-width: calc(83vw * 0.3) !important;
  min-width: 250px !important;
}
</style>